module.exports = __webpack_public_path__ + "media/images/Controller-b1543aa5.jpg";